import {
    LOGIN_USER,
    CREATE_USER,
    SEND_SMS_TO_CUSTOMER,
    GET_CUSTOMER_ACCOUNT,   
    UPDATE_CUSTOMER_ACCOUNT,
    GET_PROVINCES,
    GET_DISTRICTS,
    GET_WARDS,
    GET_WISHLIST,
    GET_COMMENTS,
} from "../actions/types";
    
export default function (state = {}, action) {
    switch (action.type) {
    case LOGIN_USER:
        return { ...state, loginSuccess: action.payload };
    case CREATE_USER:
        return { ...state, registerSuccess: action.payload };
    case SEND_SMS_TO_CUSTOMER:
        return { ...state, sendSmsSuccess: action.payload };
    case GET_CUSTOMER_ACCOUNT:
        return { ...state, userLogin: action.payload };
    case UPDATE_CUSTOMER_ACCOUNT:
        return { ...state, isSuccess: action.payload };
    case GET_PROVINCES:
        return { ...state, provinces: action.payload };
    case GET_DISTRICTS:
        return { ...state, districts: action.payload };
    case GET_WARDS:
        return { ...state, wards: action.payload };
    case GET_WISHLIST:
        return { ...state, wishList: action.payload };
    case GET_COMMENTS:
        return { ...state, comments: action.payload };
    default:
        return state;
    }
}
    